import { datadogRum } from "@datadog/browser-rum";
import { useEffect, useState } from "react";

import { useGeocodeService } from "app/MapboxProvider";
import { fleetActions } from "state/fleet/slice";
import { trackAnalytic } from "utils/trackEvent";

import { useDispatch } from "./redux";

// Use the mapbox reverse-geocode API to get the closest address to coordinates
export const useReverseGeocode = ({
  memoizedLatLng,
  deviceId,
  callerId,
}: {
  memoizedLatLng?: [number, number];
  deviceId?: string;
  /**
   * Optional callerId for analytics tracking, set it to the name of the component using this hook
   */
  callerId?: string;
}) => {
  const [address, setAddress] = useState("");
  const dispatch = useDispatch();
  const geocodeService = useGeocodeService();

  useEffect(() => {
    const fetchAddress = async () => {
      try {
        if (memoizedLatLng && geocodeService) {
          const [lat = 0, lng = 0] = memoizedLatLng;
          const eventName = callerId
            ? `${callerId}.useReverseGeocode.geocodeFetch`
            : "useReverseGeocode.geocodeFetch";
          trackAnalytic(eventName, {
            lat,
            lng,
          });
          const response = await geocodeService
            .reverseGeocode({ query: [lng, lat], mode: "mapbox.places" })
            .send();
          setAddress(response.body.features?.[0]?.place_name);
          if (deviceId) {
            // set device coordinates in redux
            dispatch(
              fleetActions.updateFleetDeviceCoordinates({
                deviceId,
                latitude: lat,
                longitude: lng,
              })
            );
          }
        }
      } catch (error) {
        datadogRum.addError("useReverseGeocode.geocodeFetchError", { memoizedLatLng, error });
      }
    };

    fetchAddress();
  }, [memoizedLatLng, deviceId, dispatch, geocodeService, callerId]);
  return address;
};
